export enum ProductIdentifierEnum {
    barcode,
    id
}